import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbarAction } from '../../containers/App/actions';
import { TP } from '../../constants/consts';

export default function useImageValidate() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (url, onSuccess) => {
    const imageContainer = document.body;
    const img = document.createElement('img');
    img.style.display = 'none';
    img.src = url;
    img.onerror = () => {
      dispatch(
        enqueueSnackbarAction({
          message: t(`${TP}.FN_IMAGE_URL_BROKEN`),
          options: {
            variant: 'error',
          },
        }),
      );
      img.remove();
    };
    img.onload = () => {
      img.remove();
      onSuccess(url);
    };
    imageContainer.appendChild(img);
  };
}
